import styles from '../components/ReportCardInfo/ReportCardInfo.module.scss';
import cn from 'classnames';

export const periodMainInfo = [
  {
    id: 1,
    text: 'До 10 дней',
    requestPeriodStyles: cn(styles.requestsPeriod),
    periodInfoKey: 'upTo10DaysCount',
    totalRequestPeriodStyles: cn(
      styles.totalRequests,
      styles.totalRequests_period
    ),
    color: '#2F80ED',
  },
  {
    id: 2,
    text: 'с 10 до 45 дней',
    requestPeriodStyles: cn(styles.requestsPeriod),
    periodInfoKey: 'from10To45DaysCount',
    totalRequestPeriodStyles: cn(
      styles.totalRequests,
      styles.totalRequests_period
    ),
    color: '#F2994A',
  },
  {
    id: 3,
    text: 'Свыше 45 дней',
    requestPeriodStyles: cn(styles.requestsPeriod),
    periodInfoKey: 'over45DaysCount',
    totalRequestPeriodStyles: cn(
      styles.totalRequests,
      styles.totalRequests_period
    ),
    color: '#EB5757',
  },
];
